/* eslint-disable no-restricted-globals */
// components/admin/PendingMarketers.jsx
import { useState, useEffect } from "react";
import { Mail, Phone, MapPin, Clock, CheckCircle, XCircle, Loader2 } from "lucide-react";
import { Calendar } from "lucide-react";
export default function PendingMarketers() {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState({});

  useEffect(() => {
    fetchPending();
  }, []);

  const fetchPending = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}marketer/pending-marketers`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      const data = await res.json();
      setPending(data.pending || []);
    } catch (err) {
      alert("Failed to load pending marketers");
    }
    setLoading(false);
  };

  const approveMarketer = async (id) => {
    setProcessing(prev => ({ ...prev, [id]: "approving" }));
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}marketer/approve-marketer/${id}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      const d = await res.json();
      if (d.success) {
        alert("Marketer approved successfully!");
        fetchPending();
      } else {
        alert(d.message || "Failed");
      }
    } catch (err) {
      alert("Network error");
    }
    setProcessing(prev => ({ ...prev, [id]: null }));
  };

  const rejectMarketer = async (id) => {
    if (!confirm("Reject this marketer application?")) return;
    setProcessing(prev => ({ ...prev, [id]: "rejecting" }));
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}admin/reject-marketer/${id}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      const d = await res.json();
      if (d.success) {
        alert("Application rejected");
        fetchPending();
      }
    } catch (err) {
      alert("Error");
    }
    setProcessing(prev => ({ ...prev, [id]: null }));
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-16 h-16 animate-spin text-purple-600 mx-auto mb-4" />
          <p className="text-xl">Loading pending applications...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-6xl mx-auto">
        <div className="bg-gray-100 p-8 rounded-2xl shadow-xl mb-10 text-center">
          <h1 className="text-4xl font-bold mb-3">Pending Marketer Applications</h1>
          <p className="text-xl opacity-90">Total: {pending.length} waiting for approval</p>
        </div>

        {pending.length === 0 ? (
          <div className="text-center py-20">
            <div className="bg-gray-200 border-2 border-dashed rounded-xl w-32 h-32 mx-auto mb-6" />
            <p className="text-2xl text-gray-600">No pending applications</p>
            <p className="text-gray-500 mt-2">All marketers have been processed</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {pending.map(m => (
              <div key={m._id} className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8 hover:shadow-2xl transition">
                <div className="flex items-center justify-between mb-6">
                  <div className="bg-purple-100 text-purple-600 w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold">
                    {m.name.split(" ").map(n => n[0]).join("")}
                  </div>
                  <span className="px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm font-medium flex items-center gap-2">
                    <Clock className="w-4 h-4" />
                    Pending
                  </span>
                </div>

                <div className="space-y-4">
                  <h3 className="text-2xl font-bold text-gray-800">{m.name}</h3>
                  <p className="flex items-center gap-3 text-gray-700">
                    <Mail className="w-5 h-5 text-purple-600" />
                    <span>{m.email}</span>
                  </p>
                  <p className="flex items-center gap-3 text-gray-700">
                    <MapPin className="w-5 h-5 text-green-600" />
                    <span>{m.state}, {m.lga}</span>
                  </p>
                  <p className="text-sm text-gray-500 flex items-center gap-2">
                    <Calendar className="w-4 h-4" />
                    Applied: {new Date(m.appliedAt).toLocaleDateString()}
                  </p>
                </div>

                <div className="flex gap-4 mt-8">
                  <button
                    onClick={() => approveMarketer(m._id)}
                    disabled={processing[m._id]}
                    className="flex-1 bg-green-600 text-white py-4 rounded-xl font-bold hover:bg-green-700 disabled:opacity-70 flex items-center justify-center gap-3 transition"
                  >
                    {processing[m._id] === "approving" ? (
                      <><Loader2 className="animate-spin w-6 h-6" /> Approving...</>
                    ) : (
                      <><CheckCircle className="w-6 h-6" /> Approve</>
                    )}
                  </button>
                  <button
                    onClick={() => rejectMarketer(m._id)}
                    disabled={processing[m._id]}
                    className="flex-1 bg-red-600 text-white py-4 rounded-xl font-bold hover:bg-red-700 disabled:opacity-70 flex items-center justify-center gap-3 transition"
                  >
                    {processing[m._id] === "rejecting" ? (
                      <><Loader2 className="animate-spin w-6 h-6" /></>
                    ) : (
                      <><XCircle className="w-6 h-6" /> Reject</>
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}